import React from 'react'
import { Button } from '../components/button/button'
import Chip from '../components/chip/chip'
import { Header } from '../components/header/header'
import { Search } from '../components/search/search'
import table from '../img/table.svg'

import commentChip from '../img/detailsazul.svg'
import chart from '../img/chart.svg'
import comment from '../img/comment icon.svg'
import '../styles/selectRoom.css'
import axiosInstance from '../auth/axiosInstance'
import { useNavigate } from 'react-router-dom'
import Filter from '../components/filter/filter'

function SelectRoom() {
    let items = [{
        title: 'Table',
        route: '/',
        img: table
    },
    // {
    //     title: 'Chart',
    //     route: '/charts',
    //     img: chart
    // },
    {
        title: 'Rooms',
        route: '/selectroom',
        img: commentChip
    }]
    const [data, setData] = React.useState([])
    const [showFilter, setShowFilter] = React.useState(false)
    const [initialData, setInitialData] = React.useState([])
    const navigate = useNavigate()

    function getData() {
        axiosInstance(`room/`)
            .then(res => {
                setData(res.data)
                setInitialData(res.data)
            })
            .catch(err => console.log(err))
    }

    React.useState(() => {
        getData()
    }, [])

    return (
        <section className='control-body'>
            <Header line>
                <Chip onClick={navigate} items={items} quantity={2} active={2} style={{ width: '600px' }} />
            </Header>
            <div className='search-area'>
                <Search initialData={initialData} set={setData} style={{ border: '1px solid #0F0742', boxShadow: '0 0 0', width: '70%' }} placeholder='Search DH' />
                <Button style={{ width: '30%' }} onClick={() => setShowFilter(!showFilter)} type='filter' />
                <Filter props={{ left: '70.5%', top: '100%', width: '27%' }} show={showFilter} function={setData} arr={initialData} objKey={'site'} valueKey={'site'} />
            </div>
            <section className='table-card-room-select-room'>
                {
                    data.map(value => {
                        return (
                            <div className='card-room-select-room'>
                                <div className='card-room-select-room_div'>
                                    <img src={comment} alt='comment icon' />
                                    <div>
                                        <h1>{value.room}</h1>
                                        <h3>Total {value.racks.length}/{value.projectedRacks}</h3>
                                    </div>
                                </div>
                                <div className='card-room-select-room_div_label'>
                                    <div>
                                        <h3>{value.site.site}</h3>
                                        <h4>Total Racks: {value.racks.length}</h4>
                                    </div>
                                    <button style={value.racks.length > 0 ? { display: 'flex' } : { display: 'none' }} onClick={() => navigate(`/details/${value.id}/${value.room}/all`)}>View</button>
                                </div>
                            </div>
                        )
                    })
                }
            </section>
        </section>
    )
}

export default SelectRoom